// Calendar dates are local dates, not UTC date slices (which can move events a day).
export function localDateString(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}

export function calendarDateRange(start, end) {
  const startDate = new Date(`${start}T00:00:00`)
  const lastDate = new Date(`${end}T00:00:00`)
  if (!/^\d{4}-\d{2}-\d{2}$/.test(start) || !/^\d{4}-\d{2}-\d{2}$/.test(end) ||
      !Number.isFinite(startDate.getTime()) || !Number.isFinite(lastDate.getTime()) ||
      localDateString(startDate) !== start || localDateString(lastDate) !== end || lastDate < startDate) {
    throw new Error('Choose a valid date range with the end on or after the start.')
  }
  // Exclusive next midnight includes the whole final day and handles DST changes.
  lastDate.setDate(lastDate.getDate() + 1)
  return { startDate, endDate: lastDate }
}

export function outlookDateTime(value) {
  const text = value?.dateTime
  if (!text) return new Date(NaN)
  if (/(Z|[+-]\d{2}:\d{2})$/i.test(text)) return new Date(text)
  // Graph returns offset-free dateTime values, even when UTC is requested.
  if (value.timeZone && !['utc', 'etc/utc'].includes(value.timeZone.toLowerCase())) {
    throw new Error('Outlook returned an unexpected timezone. Please reload your calendar.')
  }
  return new Date(`${text}Z`)
}

export const calendarEntryKey = entry => entry.external_id
  ? JSON.stringify([entry.source, entry.external_id])
  : JSON.stringify([entry.source, entry.activity_title, entry.date, entry.notes, entry.duration_minutes])

export function newCalendarEntries(entries, existing = []) {
  const seen = new Set(existing.map(calendarEntryKey))
  return entries.filter(entry => {
    const key = calendarEntryKey(entry)
    if (seen.has(key)) return false
    seen.add(key)
    return true
  })
}
